

import React from 'react';
import cert from './styling/images/certifications/certifications.jpg';

const Certifications = () => {
  
    
  return <div>
    <div>
        <style>
        {`
        .auth_cert {
            display: flex;
            flex-direction: column; 
            font-family: 'Arial', sans-serif;
            color: #333;
            margin: 0 8%;
            padding: 20px;
            max-width: 80%;
            border-radius: 8px;
            position: relative;
        }
            
        .heading {
            font-size: 32px;
            word-spacing: 5px;
            font-weight: bold;
            color: black;
            text-align: center;
            margin-bottom: 5%;
        }
            
        .auth_img{
            margin-bottom: 5%;
        }
        .row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-left: 40px;
            margin-right: 40px;
            flex-wrap: wrap;
            font-size: 18px;
            line-height: 1.6;

        }
          .row p{
            margin-bottom:2px;
            margin-top:2px;
            text-align: justify;
          }

           @media (max-width: 768px) {
              .auth_cert {
                  margin: 0 4%;
                  padding: 15px;
                  max-width: 90%;
              }

              .heading {
                  font-size: 24px;
              }

              .row {
                  margin-left: 20px;
                  margin-right: 20px;
                  font-size: 14px;
              }
          }

          /* Responsive for mobile */
          @media (max-width: 480px) {
              .auth_cert {
                  margin: 0 2%;
                  padding: 10px;
                  max-width: 100%;
              }

              .heading {
                  font-size: 18px;
                  margin-bottom: 3%;
              }

              .row {
                  margin-left: 10px;
                  margin-right: 10px;
                  font-size: 14px;
                  text-align: center;
              }

              .auth_img {
                  width: 100%;
                  height: auto;
                  margin-bottom: 10%;
              }

              .row p {
                  margin-bottom: 8px;
                  font-size: 12px;
              }
          }
            `}
        </style>
    </div>
    <div className='auth_cert'>
      <h1 className='heading'>CLIENT SATISFACTION CERTIFICATE</h1>
    <img className="auth_img" src={cert} alt="" />
    <div className="row">
      <p>We have proudly received numerous certificates from our valued clients, including <b>Product Satisfaction Certificates (PSC)</b> and <b>Service Satisfaction Certificate (SSC)</b>. With our high level of unmatched service and commitment, our customers consistently stick and praise our reliable products, competitive pricing, and trustworthy business dealing. With a focus on responsiveness, we provide swift onsite and doorstep services, keeping customer satisfaction our priority.</p>
     </div>
     <div className="row">
    <p>Our extensive client list includes corporate giants, industries, banks, hospitals, government sectors, private firms, and renowned institutions. We specialize in delivering electrical power solutions in data centers, networking, servers, and telecommunications, complemented by top-tier sales and after-sales support. Our expert technical team excels in site survey, installation and repair services, ensuring prompt and reliable service both within the city and upcity.</p>
      </div>
    <div className='row'>
    <p>As the proud owner of our own trusted brand, AROS, we also offer a wide range of other reliable brands to meet electrical power needs of our clients. From UPS systems, voltage stabilizers, and electrical power conditioners to complete range of solar power products including on-grid and hybrid inverters, solar panels, and batteries, we provide innovative electrical power solutions tailored to our customers needs. Our clients loyalty is a testament to their satisfaction, as they not only continue to choose us but also confidently prefer us to others. They proudly endorse the quality of our services, helping us build a trusted reputation across industries.</p>
    </div>
    </div>
  </div>;
};
 
export default Certifications;

